<template>
    <section>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 grid-margin">
                    <div class="card">
                        <div class="card-header">
                            <h5 class="mb-0">Lista messaggi</h5>
                        </div>
                        <div class="card-body p-0">
                            <div v-if="messages.data && messages.data.length">
                                <paginated-table
                                    v-if="messages.data"
                                    v-model="query"
                                    :columns="columns"
                                    :data="messages.data"
                                    :total="messages.total"
                                    :clickRow="true"
                                    @rowClicked="rowClicked"
                                >
                                    <template slot="children" slot-scope="props">
                                        <span v-if="props.row.broadcast">
                                            <font-awesome-icon class="text-warning" size="sm" icon="star" />
                                        </span>
                                        <span v-else>{{ props.row.children.length }}
                                            <font-awesome-icon size="sm" :icon="['far', 'comment']" />
                                        </span>
                                    </template>
                                    <template slot="title" slot-scope="props">
                                        <span :class="{ 'font-weight-bold' : props.row.status === 0 }">
                                            {{ `${ props.row.title.substring(0, 20) } (...)` }}
                                        </span>
                                    </template>
                                    <template slot="type" slot-scope="props">
                                        <span :class="{ 'font-weight-bold' : props.row.status === 0 }">
                                            {{ props.row.type || '--' }}
                                        </span>
                                    </template>
                                    <template slot="creator" slot-scope="props">
                                        <span :class="{ 'font-weight-bold' : props.row.status === 0 }">
                                            {{ props.row.creator.username }}
                                        </span>
                                    </template>
                                    <template v-if="currentUser.type === 1" slot="receiver" slot-scope="props">
                                        <span v-if="props.row.receiver" :class="{ 'font-weight-bold' : props.row.status === 0 }">
                                            {{ props.row.receiver.username }}
                                        </span>
                                        <template v-else>
                                            <i>Broadcast</i>
                                            <!-- <span class="d-block text-center">
                                                <font-awesome-icon icon="users" />
                                            </span> -->
                                        </template>
                                    </template>
                                    <template slot="created_at" slot-scope="props">
                                        <span :class="{ 'font-weight-bold' : props.row.status === 0 }">
                                            {{ $date(props.row.created_at).format('DD-MM-YYYY') }}
                                        </span><br>
                                        <small>
                                            <font-awesome-icon :icon="['far', 'clock']" />
                                            {{ $date(props.row.created_at).format('HH:mm') }}
                                        </small>
                                    </template>
                                    <template slot="actions" slot-scope="props">
                                        <div class="btn-group" role="group" aria-label="">
                                            <a title="Elimina messaggio"
                                                v-if="currentUser.type === 1 || currentUser.id === props.row.created_from"
                                                href="javascript:;"
                                                class="btn btn-sm btn-danger"
                                                @click="deleteMessage(props.row.id)">
                                                <font-awesome-icon icon="trash-alt" />
                                                <span>&nbsp;ELIMINA</span>
                                            </a>
                                        </div>
                                    </template>
                                </paginated-table>
                            </div>
                            <template v-else>
                                <div class="alert alert-info mb-0">
                                    Non esistono messaggi nel database.
                                </div>
                            </template>
                        </div>
                        <div class="card-footer">
                            <button @click="addMessage" class="btn btn-success">
                                <font-awesome-icon :icon="['far', 'envelope']" size="sm" />&nbsp;NUOVO MESSAGGIO
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <message-modal :message="currentMessage" />
    </section>
</template>
<script>
import objectProperty from '@/mixins/objectProperty'

import {
    Message
} from '@/models/Message'
import {
    mapGetters
} from 'vuex'
import {
    GET_LIST,
    DELETE
} from '@/store/actions.type'
import {
    MODULE_NAME
} from '@/store/modules/messages.module'
const DEFAULT_QUERY = {
    _page: 1,
    _limit: 10,
    _sort: '',
    _asc: 1
}
export default {
    name: 'messages-list',
    mixins: [ objectProperty ],
    data () {
        return {
            currentMessage: new Message(),
            columns: {
                // status: {
                //     label: 'Stato',
                //     priority: 5,
                //     align: 'center'
                // },
                children: {
                    label: '',
                    priority: 3,
                    align: 'center'
                },
                title: {
                    label: 'Oggetto',
                    sortable: true
                },
                type: {
                    label: 'Tipologia',
                    priority: 3
                },
                creator: {
                    label: 'Mittente',
                    priority: 3
                },
                created_at: {
                    label: 'Data creazione',
                    sortable: true,
                    priority: 4
                },
                actions: {
                    label: '',
                    align: 'right'
                }
            }
        }
    },
    mounted () {
        this.fetchMessages()
        if (this.currentUser.type === 1) {
            this.columns = this.addToObject(this.columns, 'receiver', {
                label: 'Destinatario',
                priority: 3
            }, 4)
        }
    },
    computed: {
        ...mapGetters({
            messages: `${MODULE_NAME}/getList`
        }),
        ...mapGetters([
            'isAuthenticated',
            'currentUser'
        ]),
        query: {
            get () {
                return Object.keys(this.$route.query).length == 0 ? DEFAULT_QUERY : this.$route.query
            },
            set (new_query) {
                this.$router.replace({
                    query: {
                        ...new_query
                    }
                })
            }
        }
    },
    watch: {
        $route () {
            this.$store.dispatch(`${MODULE_NAME}/${GET_LIST}`, {
                query: this.query
            })
        }
    },
    methods: {
        addMessage () {
            this.currentMessage = new Message()
            this.$nextTick(() => {
                this.$modal.show('message-modal')
            })
        },
        openMessage (message) {
            this.currentMessage = message
            this.$nextTick(() => {
                this.$modal.show('message-modal')
            })
        },
        openDetail (message) {
            this.$router.push({
                name: 'message-detail',
                params: {
                    id: message.id
                }
            })
        },
        fetchMessages () {
            this.$store.dispatch(`${MODULE_NAME}/${GET_LIST}`, {
                query: this.query
            })
        },
        deleteMessage (messageId) {
            event.stopPropagation()
            this.$swal({
                title: 'Sei sicuro?',
                text: 'Una volta eliminato non potrai più recuperare questo messaggio!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, eliminalo!'
            }).then((willDelete) => {
                if (willDelete.value) {
                    this.$store.dispatch(`${MODULE_NAME}/${DELETE}`, messageId).then(() => {
                        this.fetchMessages()
                    })
                } else {
                    this.$swal('Bene!', 'Messaggio salvo!')
                }
            })
        },
        rowClicked (e) {
            if (e.id) this.openDetail(e)
            return false
        }
    },
    components: {
        PaginatedTable: () => import('@/components/PaginatedTable'),
        MessageModal: () => import('./MessageModal'),
    }
}
</script>
